<template>
  <div>
    <a-card title="TrueLife Shop" class="style4 store">
      <a-list :grid="{ gutter: 16, xs: 1, sm: 2, md: 3 }" :data-source="products">
        <a-list-item slot="renderItem" slot-scope="item" class="mt-4">
          <router-link :to="'/orderProducts/' + item.id + '/checkout'">
            <a-card hoverable>
              <img slot="cover" :alt="item.name" :src="item.thumbnail" />
            </a-card>
            <h4>{{ item.name }}</h4>
          </router-link>
        </a-list-item>
      </a-list>
    </a-card>
  </div>
</template>
<script>
import ProductService from '@/services/ProductService';
export default {
  data() {
    return {
      products: [],
    };
  },
  async mounted() {
    await this.doInitData();
  },
  methods: {
    async doInitData() {
      try {
        const resp = await ProductService.getProducts({ product_category_id: this.$route.params.categoryId });
        this.products = resp;
      } catch (err) {
        this.$router.push({ name: 'orderProducts' });
      }
    },
  },
};
</script>
<style lang="scss">
.store {
  & > .ant-card-body {
    background: #e2f5ff !important;
  }

  .ant-list-item {
    text-align: center;
    h4 {
      margin-top: 1rem;
    }
  }
  .ant-card {
    max-width: 240px;
    margin: 0 auto;
  }

  .mt-4 {
    margin-top: 4rem !important;
  }
  .ant-row {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
